module.exports = __webpack_public_path__ + "img/share-black.cd32fbd9.svg";